const currencyFormat = currency => number =>
    new Number(number).toLocaleString(undefined, {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    });

const labelCallback = currency => context => {
    const yValue = context.raw;
    const label = context.dataset.label;
    const value = currencyFormat(currency)(yValue);
    const formattedLabel = `${label}: ${value}`;
    return formattedLabel;
};

const currencyConfig = ({ currency }) => {
    return {
        scales: {
            y: {
                beginAtZero: true,
                ticks: {
                    callback: currencyFormat(currency),
                },
                type: 'linear',
            },
        },
        plugins: {
            tooltip: {
                callbacks: {
                    label: labelCallback(currency),
                },
            },
        },
    };
};

export default currencyConfig;
